import type { Summary } from '|/app/services';

export type AutopaySummaryView =
  | { kind: 'declined' }
  | { kind: 'enrolled'; accountMask: string | null }
  | { kind: 'none' };

export const getAutopaySummary = (summary: Summary | null): AutopaySummaryView => {
  if (summary?.enrolledInAutopay === false) return { kind: 'declined' };
  if (summary?.enrolledInAutopay === true) {
    const account = summary.payment?.paymentAccounts?.find(a => a.type === 'Autopay');
    return { kind: 'enrolled', accountMask: account?.mask ?? null };
  }
  return { kind: 'none' };
};
